var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPlansBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 18C6.96667 18 6.65289 17.8696 6.392 17.6087C6.13111 17.3478 6.00044 17.0338 6 16.6667V12.5H10.6667V18H7.33333ZM12 18V12.5H18V16.6667C18 17.0333 17.8696 17.3473 17.6087 17.6087C17.3478 17.87 17.0338 18.0004 16.6667 18H12ZM6 11.1667V7.33333C6 6.96667 6.13067 6.65289 6.392 6.392C6.65333 6.13111 6.96711 6.00044 7.33333 6H16.6667C17.0333 6 17.3473 6.13067 17.6087 6.392C17.87 6.65333 18.0004 6.96711 18 7.33333V11.1667H6Z",
    fill: "#040815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPlansBlack);
export default __webpack_public_path__ + "static/media/MyPlans-Black.94e9cfa8cf9bde0d79cbc0915837a766.svg";
export { ForwardRef as ReactComponent };